import React from "react";
import AllahinHidayetGunesiLarge from '../../../assets/books/kapaklar/allahin-hidayet-gunesi_600.jpg';
import AllahinHidayetGunesiMini from '../../../assets/books/kapaklar/allahin-hidayet-gunesi-300.jpg';
export const AllahinHidayetGunesiDescription = (props: any) => {
    return (
        <div className="summary-description">
            <div className="book-image">
                <img 
                src={AllahinHidayetGunesiLarge} 
                alt="Aşka Meşke Semaya Yolculuk"
                srcSet={`${AllahinHidayetGunesiMini} 300w, ${AllahinHidayetGunesiLarge} 600w`}
                sizes={"(max-width: 600px) 300px,  600px"}
                />
            </div>
            <p>
                Elinizdeki çalışma, dünyada İslam’ı seçen bazı din adamlarının hidayet öykülerini konu almaktadır.
                Bu zatların her biri, Müslüman olmadan önce birer din adamıdır.
                İstisnasız hepsi de dinlerine adam kazandırmaya
                çalışan birer misyonerdir, hatta bazıları kardinal
                veya başpiskopos seviyesinde yüksek görevlere sahip
                kişilerdir. Acaba böylesine dinlerine bağlı, kendi inançlarına
                başka hayatları davet etmek için çabalayan, bu
                uğura hayatlarını adayan, bu yolda büyük imkân, itibar
                ve üne kavuşmuş olan bu şahıslar neden İslam’ı
                seçtiler? Hiç kuşku yok ki bu, kolay alınabilecek karar değildir.
                Sosyal çevrelerini, hatta bazen en sevdiklerini
                yitirme ve yapayalnız kalmayı göze alarak bu yolu seçmişlerdir.
                Demek ki onları buna sevk eden çok kuvvetli
                bir hakikat olmalıdır. Gerekçelerini incelediğimizde ise
                şu hususların ön plana çıktığını görürüz:
            </p>
            <p>
                Karşılarında İslam’ı güzelce temsil eden, İslam ahlakını
                hayatlarında yaşayan bir örnek bulunması onları
                İslam dinine sevk etmektedir. Bu da gösteriyor ki İslam
                ahlakını ve imanın güzelliklerini davranışlarımızla sergilersek
                diğer dinlerin mensupları grup grup İslam’a
                gireceklerdir.
            </p>
        </div>
    )
}
export const AllahinHidayetGunesiSummaryDescription = (props: any) => {
    return (
        <p>
            Elinizdeki çalışma, dünyada İslam’ı seçen bazı din adamlarının hidayet öykülerini konu almaktadır.
            Bu zatların her biri, Müslüman olmadan önce birer din adamıdır.
            İstisnasız hepsi de dinlerine adam kazandırmaya
            çalışan birer misyonerdir, hatta bazıları kardinal
            veya başpiskopos seviyesinde yüksek görevlere sahip
            kişilerdir. Acaba böylesine dinlerine bağlı, kendi inançlarına
            başka hayatları davet etmek için çabalayan, bu
            uğura hayatlarını adayan, bu yolda büyük imkân, itibar
            ve üne kavuşmuş olan bu şahıslar neden İslam’ı
            seçtiler? Hiç kuşku yok ki bu, kolay alınabilecek karar değildir.
            Sosyal çevrelerini, hatta bazen en sevdiklerini
            yitirme ve yapayalnız kalmayı göze alarak bu yolu seçmişlerdir.
            Demek ki onları buna sevk eden çok kuvvetli
            bir hakikat olmalıdır. Gerekçelerini incelediğimizde ise
            şu hususların ön plana çıktığını görürüz:
        </p>
    )
}